/**
 * Typed search params for the `/dispatch` route. The `week=` value lives in the URL so the board is
 * deep-linkable AND compile-checked (the fleet/inventory `searchParams` pattern). TanStack Router
 * validates the raw URL params through `validateDispatchSearch` on every navigation.
 *
 * `?week=YYYY-MM-DD` selects the week (any day in the week — the server resolves the Monday). An
 * absent / malformed `week=` falls back to the current week server-side. The SPA NEVER sends a
 * tenant id (SEC-11).
 */

import { isValidDate } from './weekModel.js';

export interface DispatchSearch {
  week?: string;
}

/**
 * TanStack Router `validateSearch` for the dispatch board route. Keeps `week` only when it is a
 * calendar-real YYYY-MM-DD so the canonical URL stays clean (`/dispatch` vs
 * `/dispatch?week=2026-06-15`).
 */
export function validateDispatchSearch(raw: Record<string, unknown>): DispatchSearch {
  const search: DispatchSearch = {};
  const week = typeof raw.week === 'string' ? raw.week : undefined;
  if (week && isValidDate(week)) search.week = week;
  return search;
}
